import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, useQueryParam } from 'use-query-params';

import { queryKeys } from '../constants';
import { UpdateWidgetModel } from '../models';

export function useUpdateWidgetName() {
  const qc = useQueryClient();
  const [dashboardId] = useQueryParam('dashboardId', NumberParam);

  return useMutation({
    mutationFn: async (data: UpdateWidgetModel & { id: number }) => {
      const res = await $api.patch(`/v1/dashboard/widget/${data?.id}`, data);

      return res.data;
    },
    onSuccess: async res => {
      showMessage(res.message, true);

      await qc.invalidateQueries([queryKeys.DASHBOARD_WIDGETS, dashboardId]);
      // qc.setQueryData(
      //   [queryKeys.DASHBOARD_WIDGETS, dashboardId],
      //   // @ts-expect-error
      //   ({ widgets }: { widgets: dashboardV2Models.WidgetModel[] }) => ({
      //     widgets: widgets?.map(item => ({
      //       ...item,
      //       name: id === item?.id ? name : item?.name
      //     }))
      //   })
      // );
    },
    onError: baseErrorHandler
  });
}
